import { useMutation, useQuery } from '@apollo/client'
import { ErrorComponent, ProgressSpinner } from '@medical/components'
import {
  STAFF_CREATE_GROUP,
  STAFF_DELETE_GROUP,
  STAFF_UPDATE_GROUP,
} from '@medical/constant/permissions'
import { checkStaffPermission } from '@medical/libs'
import { useCustom } from '@medical/provider/context'
import React from 'react'
import { useLocation } from 'react-router-dom'

import { DELETE_STAFF_GROUP, STAFF_GROUPS2 } from './StaffGroupsList.graphql'
import StaffGroupsListScene from './StaffGroupsListScene'

const StaffGroupsList = () => {
  const [{ i18n, popup }] = useCustom()
  const location = useLocation()
  const { loading, error, data, refetch } = useQuery(STAFF_GROUPS2)
  const isCreatePermitted = checkStaffPermission({
    functionName: STAFF_CREATE_GROUP,
  })
  const isDeletePermitted = checkStaffPermission({
    functionName: STAFF_DELETE_GROUP,
  })
  const isUpdatePermitted = checkStaffPermission({
    functionName: STAFF_UPDATE_GROUP,
  })
  const [deleteStaffGroup] = useMutation(DELETE_STAFF_GROUP, {
    refetchQueries: [
      {
        query: STAFF_GROUPS2,
      },
    ],
    awaitRefetchQueries: true,
  })

  if (loading) return <ProgressSpinner />
  if (error) return <ErrorComponent error={error} />

  const onSubmit = async ({ staffGroupId }, { setSubmitting, resetForm }) => {
    try {
      await deleteStaffGroup({
        variables: {
          staffGroupId,
        },
      })
      popup.success(i18n.t('staff.staffGroup.deleteSuccess'))
      setSubmitting(false)
      resetForm()
    } catch (error) {
      popup.error(error)
      setSubmitting(false)
    }
  }

  return (
    <StaffGroupsListScene
      i18n={i18n}
      staffGroups={data.staffGroups}
      onSubmit={onSubmit}
      isCreatePermitted={isCreatePermitted}
      isDeletePermitted={isDeletePermitted}
      isUpdatePermitted={isUpdatePermitted}
      location={location}
      refetch={refetch}
    />
  )
}

export default StaffGroupsList
